require.register("ffss/component/row/formation/Map", function(exports, require, module){
  $0
  
});

